import { Box, Text } from "@radix-ui/themes";
import { produce } from "immer";
import { useState } from "react";
import Button from "../../buttons/Button";
import MultipleChoiceQuestion from "../screens/MultiChoiceQuestionProps";
import SingleChoiceQuestion from "../screens/SingleChoiceQuestion";
import { ConfirmSubmitPage } from "./ConfirmSubmitPage";
import Wizard from "./Wizard";
import { SubmitSuccessScreen } from "./SubmitSuccessPage";
import TaskService from "services/TaskService";
import { alertInstance } from "components/alert";
import { useNavigate } from "react-router-dom";


enum Step {
  Instruction,
  Assessment,
  ConfirmSubmit,
  Result,
  MandatoryRemaining,
}

const Quiz = ({ task }: { task: any }) => {

  const [questions, setQuestions] = useState<any>(task.assessment.questions.assessmentDetails.questionDetails);
  const [step, setStep] = useState<Step>(Step.Instruction);
  const taskService = new TaskService();
    const router = useNavigate();
  

  console.log("task", task);
  const handleSingleChoice = (option: any, index: number) => {
    setQuestions(produce((questions: any) => {
      questions[index].answer = questions[index].answerOptions.map((el: any, index: number) => {
        if (index == option.answerId) {
          el.isAnswer = true;
        } else el.isAnswer = false;
        return el
      })
    }))
  };

  const updateMultiChoiceValue = (option: any, index: number) => {
    setQuestions(produce((questions: any) => {
      questions[index].answer = questions[index].answerOptions.map((el: any, index: number) => {
        if (index == option.answerId) {
          el.isAnswer = !el.isAnswer
        }
        return el
      })
    }));
  };
  const validateTest = () => {
    let checkMandatoryQuestions = [];
    questions.map((item: any) => {
      if (item.Mandatory && !item.answer.some((item: any) => item.isAnswer === true))
        checkMandatoryQuestions.push(item.id);
    });
    return checkMandatoryQuestions.length ? false : true;
  };

  const handleSubmit = async (taskId = task?.id) => {
    if (!validateTest()) {
      setStep(Step.MandatoryRemaining);
    } else {
      const data = { ans: [...Object.values(questions)] };
      const res: any = await taskService.submit(taskId, data);
      if (res.code === 200) {
        setStep(Step.ConfirmSubmit);
      } else {
        alertInstance.emit("showAlert", {
          type: "error",
          heading: "Something Went Wrong",
          buttonText: "ok",
        });
      }
    }
  };

  const calculateScore = (questions: any) => {
    let correctCount = 0;

    questions.forEach((question: any) => {
      if (question.questionType.toLowerCase() === "single choice") {
        // Single Choice: Correct if the selected option is the right answer and only one option is selected
        const selected = question.answer.filter((opt: any) => opt.isAnswer);
        if (
          selected.length === 1 &&
          selected[0].isAnswer &&
          selected[0].rightAnswer
        ) {
          correctCount++;
        }
      } else if (question.questionType.toLowerCase() === "multiple choice") {
        // Multiple Choice: Correct if all right answers are selected and no wrong answers are selected
        const allRightSelected = question.answer.every((opt: any) =>
          opt.rightAnswer ? opt.isAnswer : !opt.isAnswer
        );
        const allRequiredSelected = question.answer
          .filter((opt: any) => opt.rightAnswer)
          .every((opt: any) => opt.isAnswer);
        if (allRightSelected && allRequiredSelected) {
          correctCount++;
        }
      }
    });

    return correctCount;
  };

  return (
    <div>
      {step == Step.Instruction && (
        <Box>
          <Text className="font-bold text-app-blue mb-2">
            Total number of questions: {questions.length}
          </Text>
          <div className="border-b-2 border-app-blue mb-2"></div>
          <Text className="block font-medium italic">Instruction:</Text>
          <Text>{task.description}</Text>
          <Box className="mt-4">
            <button className="btn-primary" onClick={() => { setStep(Step.Assessment) }}>Start Quiz</button>
          </Box>
        </Box>
      )}

      {step === Step.Assessment && (
        <Wizard
          handleSubmit={() => handleSubmit(task.id)}
          // handleSubmit={() => handleSubmit(task, assessmentState)}
          heading={""}
          steps={questions.map(
            (item: any, index: number) => {
              if (item.questionType.toLowerCase() === "single choice")
                return (
                  <SingleChoiceQuestion
                    key={index}
                    onChoice={handleSingleChoice}
                    question={item.question}
                    options={item.answerOptions.map((el: any, key: number) => ({ answerId: key, value: el.answerOption, isAnswer: el.isAnswer || false, isRightAnswer: el.rightAnswer }))}
                    isMandatory={false}
                    index={index}
                    assessmentType={task.assessmentType}
                  />
                );
              if (item.questionType.toLowerCase() === "multiple choice")
                return (
                  <MultipleChoiceQuestion
                    key={index}
                    question={item.question}
                    options={item.answerOptions.map((el: any, key: number) => ({ answerId: key, value: el.answerOption, isAnswer: el.isAnswer || false, isRightAnswer: el.rightAnswer }))}
                    index={index}
                    updateAnswers={updateMultiChoiceValue}
                    isMandatory={item.Mandatory}
                    questionId={item.id}
                    surveyState={task}
                    assessmentType={task.assessmentType}


                  />
                );
            }
          )}
        ></Wizard>
      )}

      {step === Step.ConfirmSubmit && (
        <ConfirmSubmitPage
          onSubmit={() => { setStep(Step.Result) }}
          setStep={setStep}
          prevStep={Step.Assessment}
        />
      )}

      {/* {step === Step.Result && (
        <SubmitSuccessScreen
          message={
            task.assessmentType === "quiz"
              ? "Thank you for completing the quiz"
              : "Thank you for completing the assessment"
          }
        />
      )} */}


      {step === Step.MandatoryRemaining && (
        <div className="flex flex-col gap-5 px-[1.5%]">
          <p>
            You have missed to respond to mandatory question/s. please go back
            and respond to all mandatory question to complete this Assessment.
          </p>
          <Button
            styles="border-2  border-app-blue outline-none py-2 w-32 bg-gradient-to-br from-purple-900  to-purple-500 text-white"
            onClick={() => setStep(Step.Assessment)}
          >
            Ok
          </Button>
        </div>
      )}

      {step === Step.Result && (
        <div className="flex flex-col gap-5 px-[1.5%]">
          <p className="text-gray-600 ml-4">Thank you for completing the Quiz</p>
          <div className="h-50 w-80 bg-gray-200 py-6 px-16 my-4 mx-4 rounded-3xl shadow-lg">
            <p className="text-sm text-gray-500">Your Score</p>
            <h3 className="text-4xl font-bold">
              <span className="text-[#43A047]">{calculateScore(questions)}</span>
              <span className="text-[#545455]">/{questions.length}</span>
            </h3>
            <p className="text-sm text-[#43A047] mt-2">Right Responses</p>
          </div>
          <Button
            styles="border-2  border-app-blue outline-none py-2 w-32 bg-gradient-to-br from-purple-900  to-purple-500 text-white ml-4"
            onClick={() => router(-1)}
          >
            OK
          </Button>
        </div>
      )}
    </div>
  );
};

export default Quiz;
